<div class="table-container mat-elevation-z2 mx-1 mt-4">
  <div class="row justify-between align-center" style="padding: 1em">
    <!-- Filtros -->
    <app-filtro-tabla
      class="flex-1"
      [datos]="[evento, fecha]"
      [search]="search"
      (onFilterChange)="cambioFiltro($event)"
    />
    <!-- Columnas -->
    <app-column-select
      [(columns)]="columnas"
      [columnNames]="nombreColumnas"
      [saveName]="saveColumnas"
    />
  </div>

  <!-- Pagination -->
  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />

  <!-- Tabla -->
  <mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortChange($event)"
  >
    <!-- Columna fechaEnvio  -->
    <ng-container matColumnDef="fechaEnvio">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Fecha
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Fecha:</span>
        {{ row.fechaEnvio | date: "short" }}
      </mat-cell>
    </ng-container>

    <!-- Columna urlDestino  -->
    <ng-container matColumnDef="urlDestino">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Endpoint
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Endpoint:</span>
        {{ row.urlDestino }}
      </mat-cell>
    </ng-container>

    <!-- Columna tipoEnvio  -->
    <ng-container matColumnDef="tipoEnvio">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Tipo
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Tipo:</span>
        <span style="text-overflow: ellipsis; max-width: 100%">
          {{ row.tipoEnvio }}
        </span>
      </mat-cell>
    </ng-container>

    <!-- Columna respuesta  -->
    <ng-container matColumnDef="respuesta">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Respuesta
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Respuesta:</span>
        {{ row.respuesta | json }}
      </mat-cell>
    </ng-container>

    <!-- Columna body  -->
    <ng-container matColumnDef="body">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Body
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Body:</span>
        <button
          mat-icon-button
          color="accent"
          (click)="mostrarBody(row.body)"
          matTooltip="Ver Body de la Petición"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <!-- Columna credenciales  -->
    <ng-container matColumnDef="credenciales">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        Credenciales
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">Credenciales:</span>
        <button
          mat-icon-button
          color="primary"
          (click)="mostrarCredenciales(row.credenciales)"
          matTooltip="Ver Credenciales de la Petición"
          style="margin-right: 10px"
        >
          <mat-icon>visibility</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnas; sticky: true" />
    <mat-row *matRowDef="let row; columns: columnas" />
  </mat-table>

  <!-- Pagination -->
  <mat-paginator
    [length]="totalCount"
    [pageSize]="helper.pageSize"
    [pageSizeOptions]="helper.pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="pageEvent($event)"
  />
</div>
